import { Link, Navigate, useParams } from 'react-router';
import { Page } from '../components';
import { DOORS, isDoor, type Door } from '../lib/doors';

export function Welcome() {
  return (
    <Page>
      <h1>Welcome to Curentia</h1>
      <p className="muted">Your health records stay encrypted on your own devices. Choose how you use Curentia.</p>
      <nav className="doors" aria-label="Choose your account type">
        {(Object.keys(DOORS) as Door[]).map((door) => (
          <Link key={door} to={`/start/${door}`} className="door">
            <strong>{DOORS[door].label}</strong>
            <span>{DOORS[door].blurb}</span>
          </Link>
        ))}
      </nav>
      <div className="links">
        <Link to="/restore">Restore from a backup file</Link>
      </div>
    </Page>
  );
}

export function Start() {
  const { door } = useParams();
  if (!isDoor(door)) return <Navigate to="/welcome" replace />;
  return (
    <Page>
      <h1>{DOORS[door].label}</h1>
      <p className="muted">{DOORS[door].blurb}</p>
      <div className="stack">
        <Link to={`/signup/${door}`} className="button">
          Create an account
        </Link>
        <Link to={`/login/${door}`} className="button secondary">
          Sign in
        </Link>
      </div>
      <div className="links">
        <Link to="/welcome">Back</Link>
      </div>
    </Page>
  );
}
